import { Inject, Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild
} from '@angular/router';
import { MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { AuthService } from 'src/app/modules/auth';
import { DynamicAsideMenuService } from 'src/app/_metronic/core';
import { authLocalStorageToken } from '../shared/common/helper';
import { SSOService } from '../sso/sso.service';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private api: ApiService,
    private sso: SSOService,
    private authService: AuthService,
    private menu: DynamicAsideMenuService,
    private authMsalService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = JSON.parse(localStorage.getItem(authLocalStorageToken));
    if (!token) {
      this.loginSSO();
      return false;
    }

    // UserInfo data
    let currentUser = this.authService.currentUserValue;

    // SSO pass then get userInfo
    if (this.sso.hasValidAccessToken && !currentUser) {
      this.api.loadingCustomOn();
      await new Promise((resolve) => {
        this.authService.getUserByToken().subscribe().add(resolve);
      });
      currentUser = this.authService.currentUserValue;
      this.api.loadingCustomOff();
    }

    const accountMsalCount = this.authMsalService.instance.getActiveAccount();

    // Check isAllow
    if (currentUser || !!accountMsalCount) {
      // pass login
      return true;
    } else {
      // not pass
      this.authService.logout();
      return false;
    }
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Check permission
    if (!this.menu.menuPermission$.value) {
      await this.menu.loadPermissions();
    }
    const r = childRoute.data;
    const isAllow = this.menu.menuPermission$.value?.find(f => f.controller == r?.screenKey || r?.screenKey === 'allow');
    return !!isAllow;
  }

  public loginSSO() {
    this.api.loadingCustomOn();
    // initCodeFlow
    //this.sso.initImplicitFlow();

    //login with azure msal
    const authRequest = this.msalGuardConfig.authRequest
      ? { ...this.msalGuardConfig.authRequest } as RedirectRequest
      : undefined;

    /**
     * Bắt buộc phải có nhánh error: guard chặn route và bật spinner, nếu loginRedirect
     * thất bại mà không tắt spinner thì người dùng kẹt ở màn hình trắng có spinner quay
     * mãi, không có cách nào thao tác tiếp.
     */
    this.authMsalService.loginRedirect(authRequest).subscribe({
      error: (error) => {
        console.error('[MSAL] loginRedirect từ AuthGuard thất bại.', error);
        // errorMessage() tự tắt loading và hiện popup cho người dùng
        this.api.errorMessage('Không thể chuyển tới trang đăng nhập. Vui lòng tải lại trang!');
      }
    });
  }
}
